import { apiClient } from '@lib/axios';

export interface AppSettingDto {
  _id: string;
  installmentCycleDays: number;
  notifications: { newAdmission: boolean; newInstallment: boolean };
}

export interface UpdateSettingDto {
  installmentCycleDays?: number;
  notifications?: { newAdmission: boolean; newInstallment: boolean };
}

export const settingsService = {
  get:    ()                      => apiClient.get<{ setting: AppSettingDto }>('/settings'),
  update: (body: UpdateSettingDto) => apiClient.put<{ setting: AppSettingDto }>('/settings', body),
};
